module.exports = __webpack_public_path__ + "img/signature.b5f2f979.svg";